import sanitizeHtml from 'sanitize-html';
import { ATTACHMENT_TYPE } from 'features/chat/constant';

const transformToNotifMessage = (
  rawText: string,
  type: keyof typeof ATTACHMENT_TYPE,
): string => {
  let text = sanitizeHtml(rawText);
  const attachmentContentMapper = {
    [ATTACHMENT_TYPE.ATTACHMENT_TYPE_PHOTO]: ' *IMAGE*',
    [ATTACHMENT_TYPE.ATTACHMENT_TYPE_GIF]: ' *GIF*',
    [ATTACHMENT_TYPE.ATTACHMENT_TYPE_POST]: ' *POST*',
    [ATTACHMENT_TYPE.ATTACHMENT_TYPE_STICKER]: ' *STICKER*',
    [ATTACHMENT_TYPE.ATTACHMENT_TYPE_PDF]: '',
    [ATTACHMENT_TYPE.ATTACHMENT_TYPE_UNSPECIFIED]: '',
    [ATTACHMENT_TYPE.ATTACHMENT_TYPE_SHARETRADE]: '',
  };

  text += attachmentContentMapper[type];
  return text;
};

export { transformToNotifMessage };
